import { atomWithStorage } from 'jotai/utils';
export const messageStyleAtom = atomWithStorage('message_style', 'beautified');
